module.exports = __webpack_public_path__ + "static/media/spectrum_avatar.6d9f2e12.svg";